/** biome-ignore-all assist/source/organizeImports: <explanation> */
import {
  GenericWrapperWithIdNavigateAndBackUrl,
  GenericWrapperWithNavigate,
  GenericWrapperWithNavigateAndBackUrl,
} from "../genericWrappers";
import ProductReturnRequestForm from "../../ProductReturnRequest/New/ProductReturnRequestForm";
import Index from "../../ProductReturnRequest/Index/index";
import NoRouteErrorPage from "../no-route-error-page"
import Details from "../../ProductReturnRequest/Details/Details";

const productReturnRequestRoutes = [
  {
    path: "ProductReturnRequest",
    children: [
      {
        path: "index",
        element: (
          <GenericWrapperWithNavigate
            key={"CustomerComplaintForm/index"}
            component={Index}
          />
        ),
      },
      {
        path: "details/:id",
        element: (
          <GenericWrapperWithIdNavigateAndBackUrl
            key={"CustomerComplaintForm/details/:id"}
            component={Details}
          />
        ),
      },
      {
        path: "new",
        element: (
          <GenericWrapperWithNavigateAndBackUrl
            key={"CustomerComplaint/new"}
            component={ProductReturnRequestForm}
          />
        ),
      },
      {
        path: "*",
        element: (
          <NoRouteErrorPage/>
        ),
      },
    ],
  },
];

export default productReturnRequestRoutes;
